var _g, _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoneQueuePoolIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1762_2973)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.33398,
    y: 4.23486,
    width: 38.5,
    height: 38.5,
    rx: 4,
    fill: "#E4E4E4"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3301 29.625H22.33H20.4474C19.4426 29.625 18.6145 28.7968 18.6145 27.7921V20.8885C18.6145 19.8837 19.4426 19.0559 20.4474 19.0559H26.7231C27.7279 19.0559 28.5562 19.8837 28.5562 20.8885V21.5162C28.5561 21.6694 28.4953 21.8163 28.3868 21.9246L28.3868 21.9246C28.2785 22.0329 28.1315 22.0938 27.9785 22.0937H27.9784C27.6594 22.0937 27.401 21.8352 27.4008 21.5162C27.4008 21.5162 27.4008 21.5162 27.4008 21.5162V20.8885C27.4008 20.5068 27.1047 20.2111 26.7231 20.2111H20.4474C20.0657 20.2111 19.7696 20.5068 19.7696 20.8885V27.792C19.7696 28.1737 20.0657 28.4698 20.4474 28.4698H22.33C22.4832 28.4698 22.6302 28.5306 22.7386 28.6389C22.8469 28.7472 22.9078 28.8941 22.9078 29.0473C22.9078 29.2006 22.847 29.3475 22.7386 29.4559C22.6303 29.5642 22.4833 29.6252 22.3301 29.625Z",
    fill: "white",
    stroke: "#E4E4E4",
    strokeWidth: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7135 25.5958V25.5958C27.7134 25.2216 27.41 24.9184 27.0358 24.9184H26.4083C26.2287 24.9184 26.0563 24.9897 25.9291 25.1167L25.9291 25.1167C25.8021 25.2438 25.7306 25.4162 25.7306 25.5958C25.7306 25.7756 25.8019 25.948 25.9291 26.0752C26.0561 26.2023 26.2285 26.2737 26.4083 26.2737H27.0358C27.2156 26.2737 27.3879 26.2023 27.515 26.0752C27.6422 25.948 27.7135 25.7756 27.7135 25.5958ZM23.634 24.6544C23.634 23.6496 24.462 22.8215 25.4666 22.8215H31.7427C32.7475 22.8215 33.5757 23.6496 33.5757 24.6544V31.5582C33.5757 32.5629 32.7475 33.3908 31.7427 33.3908H25.4666C24.462 33.3908 23.634 32.5629 23.634 31.5582V24.6544Z",
    fill: "white",
    stroke: "#E4E4E4",
    strokeWidth: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.886 25.2818V25.2818C17.886 25.1285 17.8251 24.9817 17.7168 24.8734C17.6085 24.7651 17.4615 24.7042 17.3083 24.7043H17.3082H15.4256C15.044 24.7043 14.7482 24.4081 14.7482 24.0266V17.1229C14.7482 16.7413 15.0441 16.4454 15.4256 16.4454H21.7017C22.0833 16.4454 22.3792 16.7413 22.3792 17.1229V17.7506C22.3792 18.0696 22.6378 18.3281 22.9566 18.3282L17.886 25.2818ZM17.886 25.2818C17.8861 25.4351 17.8252 25.582 17.7169 25.6903C17.6085 25.7987 17.4615 25.8595 17.3082 25.8595H15.4256C14.4208 25.8595 13.593 25.0314 13.593 24.0266V17.1229C13.593 16.1181 14.4208 15.2902 15.4256 15.2902M17.886 25.2818L15.4256 15.2902M15.4256 15.2902H21.7017C22.7065 15.2902 23.5344 16.1181 23.5344 17.1229V17.7506C23.5344 17.9039 23.4735 18.0508 23.3652 18.1591M15.4256 15.2902L23.3652 18.1591M23.3652 18.1591C23.2567 18.2674 23.1098 18.3282 22.9566 18.3282L23.3652 18.1591Z",
    fill: "white",
    stroke: "#E4E4E4",
    strokeWidth: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7883 18.0645V18.0645C15.7881 18.2176 15.849 18.3645 15.9574 18.473C16.0657 18.5813 16.2125 18.6422 16.3657 18.6422H16.9935C17.1466 18.6422 17.2936 18.5813 17.4019 18.473C17.5102 18.3646 17.5709 18.2176 17.5709 18.0645L15.7883 18.0645ZM15.7883 18.0645C15.7883 17.7456 16.0468 17.487 16.3657 17.487M15.7883 18.0645L16.3657 17.487M16.3657 17.487H16.9935C17.3123 17.487 17.5708 17.7456 17.5709 18.0645L16.3657 17.487Z",
    fill: "white",
    stroke: "#E4E4E4",
    strokeWidth: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3875 21.2526H21.3875L22.015 21.2526L22.015 21.2526C22.1683 21.2525 22.3152 21.3134 22.4235 21.4217C22.5318 21.53 22.5927 21.6768 22.5927 21.8301L22.5927 21.8301C22.5929 21.9832 22.532 22.1303 22.4237 22.2386C22.3152 22.3469 22.1682 22.4078 22.015 22.4078H21.3875C21.2344 22.4078 21.0873 22.3469 20.979 22.2386C20.8707 22.1303 20.8098 21.9832 20.8098 21.8301H20.7598L20.8098 21.8301C20.8099 21.6768 20.8707 21.53 20.9791 21.4217L20.9792 21.4217C21.0875 21.3134 21.2344 21.2525 21.3875 21.2526ZM22.015 21.2026H21.3875H22.015Z",
    fill: "white",
    stroke: "#E4E4E4",
    strokeWidth: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1762_2973",
    x: 0.333984,
    y: 0.234863,
    width: 46.5,
    height: 46.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1762_2973"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1762_2973",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoneQueuePoolIcon);
export default __webpack_public_path__ + "static/media/none-queue-pool-icon.60406150dc9dd86e1a0a9bfe22f3222f.svg";
export { ForwardRef as ReactComponent };